module.exports = __webpack_public_path__ + "static/favicon-5abae25cd9472cff8bbbb28cf81b1d77.png";